<ng-template cdk-portal #SideAlertView>

    <div class="side-alerts-container">
        @if (isShowEnableGuide) {
            <div class="side-alert-container cursor-pointer" (click)="enableGuide()">
                <div class="side-alert-content">
                    <span>Attiva revisione guidata</span>
                </div>
            </div>
        }

        @if (isShowKeepAnswer) {
            <div class="side-alert-container cursor-pointer" (click)="keepAnswerClicked()">
                <div class="side-alert-content">
                    <p>Mantieni la risposta</p>
                    <p [hidden]="!KeepAnswerofQuestion">alla domanda {{KeepAnswerofQuestion}}</p>
                </div>
            </div>
        }

        @if (isShowDeactivateGuide) {
            <div class="side-alert-container cursor-pointer" (click)="deactivateGuide()">
                <div class="side-alert-content">
                    <span>Disattiva revisione guidata</span>
                </div>
            </div>
        }

        @if (isViewQuestionInfo) {
            <div class="side-alert-container">
                <div class="side-alert-content">
                    <span>Clicca sulla domanda per info</span>
                </div>
                <div class="side-alert-close-btn-container">
                    <i class="fa-solid fa-xmark side-alert-close-btn" (click)="isViewQuestionInfo = false"></i>
                </div>
            </div>
        }

        @if (isViewClickProductInfo) {
            <div class="side-alert-container">
                <div class="side-alert-content">
                    <span>Clicca su nome prod. per dettaglio</span>
                </div>
                <div class="side-alert-close-btn-container">
                    <i class="fa-solid fa-xmark side-alert-close-btn" (click)="isViewClickProductInfo = false"></i>
                </div>
            </div>
        }

        @if (isShowProductDetailInfo) {
            <div class="side-alert-container">
                <div class="side-alert-content">
                    <span>Clicca sulle voci per info</span>
                </div>
                <div class="side-alert-close-btn-container">
                    <i class="fa-solid fa-xmark side-alert-close-btn" (click)="isShowProductDetailInfo = false"></i>
                </div>
            </div>
        }
    </div>

</ng-template>
